import { render, staticRenderFns } from "./DocsDetailParameter.vue?vue&type=template&id=f43f9c96&"
import script from "./DocsDetailParameter.vue?vue&type=script&lang=js&"
export * from "./DocsDetailParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports